import { Client } from "../../../../../axios";
const LIMIT = 20;
const PAGE = 1;

export const getCategoryMapping = async (params) => {
  const { page, limit = 50 } = params;

  const {
    data: { data, paginate },
  } = await Client.get("uudesr/design-requisition/user-category-mapping", {
    params: { ...params, limit: params.limit || 50 },
  });
  return {
    data: data,
    params: page,
    totalPages: limit !== "none" ? Math.ceil(paginate.totalCount / limit) : 1,
  };
};
export const getCategories = async ({ name, page }) => {
  const {
    data: { data, paginate },
  } = await Client.get(`uudesr/design-requisition/category`, {
    params: { limit: LIMIT, page: page || PAGE, search: name || "" },
  });
  return {
    data,
    page: page || PAGE,
    totalPages: !!name ? 1 : Math.ceil(paginate.totalCount / LIMIT),
  };
};
export const getSubCategories = async ({ name, categoryId, page }) => {
  const {
    data: { data, paginate },
  } = await Client.get(`uudesr/design-requisition/subcategory`, {
    params: {
      limit: LIMIT,
      page: page || PAGE,
      categoryId: categoryId,
      search: name || "",
    },
  });
  return {
    data,
    page: page || PAGE,
    totalPages: !!name ? 1 : Math.ceil(paginate.totalCount / LIMIT),
  };
};

// POST
export const UpdateCategories = async ({ payload, type }) => {
  const res = await Client?.[type](
    `uudesr/design-requisition/category`,
    payload
  );
  return res.data.data;
};
export const UpdateSubCategories = async ({ payload, type }) => {
  const res = await Client?.[type](
    `uudesr/design-requisition/subcategory`,
    payload
  );
  return res.data.data;
};
export const updateCategoryMapping = ({ payload, type }) => {
  const res = Client?.[type](
    `uudesr/design-requisition/user-category-mapping`,
    payload
  );
  return res;
};
